module.exports = __webpack_public_path__ + "img/index-phone.19991b18.png";